const stories = [
  {
    image:
      "https://static.prod-images.emergentagent.com/jobs/977ef603-d9dd-4522-8291-8392552a5165/images/2aa577a1c10c1c98caf042ba2c5eef896e4a14f710efe204ce12a5a47eb2af54.png",
    alt: "Elder passing indigenous seeds to a young person",
    tag: "Elders",
    headline: "Knowledge held. Knowledge passed on.",
    body: "Elders share seasonal calendars, bush food knowledge and cultural protocols — anchoring every garden in the wisdom of Country.",
  },
  {
    image: "https://customer-assets.emergentagent.com/job_country-gardens/artifacts/wn8wu4va_seed%20indigenous%20yourth.jpg",
    alt: "Young person on Country handling seed heads in a Munkarta School jersey",
    tag: "Young People",
    headline: "Skills for land, life, and livelihood.",
    body: "Schools and youth programs grow alongside our gardens — reconnecting young people with land care, nutrition, and real career pathways.",
  },
  {
    image: "https://images.pexels.com/photos/33165326/pexels-photo-33165326.jpeg",
    alt: "Torres Strait islands coastline",
    tag: "Country",
    headline: "From desert to Torres Strait.",
    body: "Climate-adapted designs let us work everywhere — central desert, Top End, tropical north, and the coastal communities of the Torres Strait.",
  },
];

export default function Impact() {
  return (
    <section
      id="impact"
      data-testid="impact-section"
      className="relative bg-sand py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-16 md:mb-24">
          <div className="md:col-span-7">
            <div className="text-xs uppercase tracking-[0.3em] text-rust mb-6">
              The Ripple
            </div>
            <h2
              data-testid="impact-heading"
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-charcoal"
            >
              When communities grow food locally,
              <span className="block italic text-sage">
                the impact reaches far beyond nutrition.
              </span>
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9">
            <p className="text-base md:text-lg leading-relaxed text-ink">
              Pride. Participation. Resilience. The garden is just the
              beginning of what gets restored.
            </p>
          </div>
        </div>

        {/* Storytelling grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {/* First story - large */}
          <article
            data-testid="impact-story-0"
            className="md:col-span-7 md:row-span-2 group"
          >
            <div className="relative overflow-hidden">
              <img
                src={stories[0].image}
                alt={stories[0].alt}
                className="w-full aspect-[4/5] md:aspect-[4/5] object-cover transition-transform duration-[1500ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/85 via-charcoal/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12 text-sand">
                <div className="text-xs uppercase tracking-[0.3em] text-ochre mb-4">
                  {stories[0].tag}
                </div>
                <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl font-light leading-tight">
                  {stories[0].headline}
                </h3>
                <p className="mt-5 max-w-md text-sand/85 leading-relaxed">
                  {stories[0].body}
                </p>
              </div>
            </div>
          </article>

          {/* Second and third stories */}
          {stories.slice(1).map((s, i) => (
            <article
              key={i}
              data-testid={`impact-story-${i + 1}`}
              className="md:col-span-5 group"
            >
              <div className="relative overflow-hidden">
                <img
                  src={s.image}
                  alt={s.alt}
                  className="w-full aspect-[4/3] object-cover transition-transform duration-[1500ms] group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/85 via-charcoal/5 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 text-sand">
                  <div className="text-[11px] uppercase tracking-[0.3em] text-ochre mb-3">
                    {s.tag}
                  </div>
                  <h3 className="font-serif text-2xl md:text-3xl font-light leading-tight">
                    {s.headline}
                  </h3>
                  <p className="mt-3 text-sm text-sand/80 leading-relaxed">
                    {s.body}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Impact stats strip */}
        <div className="mt-20 md:mt-28 border-t border-stone-line/70 pt-12 grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-10">
          {[
            { num: "12", label: "communities engaged in pilot phase" },
            { num: "4,800kg", label: "fresh produce projected per garden, per year" },
            { num: "50+", label: "young people in accredited training pathways" },
            { num: "100%", label: "community-owned, community-led outcomes" },
          ].map((s, i) => (
            <div key={i} data-testid={`impact-stat-${i}`}>
              <div className="font-serif text-4xl md:text-5xl text-rust tick-num leading-none">
                {s.num}
              </div>
              <div className="mt-3 text-[11px] uppercase tracking-[0.22em] text-ink/80 leading-relaxed">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
